import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  // {
  //   path: '/preview',
  //   name: 'preview',
  //   component: FilePreview,
  //   children: []
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
